import React from 'react';
import './DelmomentProgressRing.css';

interface DelmomentProgressRingProps {
    /** Completed delmoment (work orders). */
    completed: number;
    /** Total non-cancelled delmoment. */
    total: number;
    /** Pixel size of the ring (default 36). */
    size?: number;
}

/**
 * Subtle donut ring showing delmoment completion progress, with a dark,
 * instantaneous tooltip on hover. Renders nothing when there are no delmoment.
 */
const DelmomentProgressRing: React.FC<DelmomentProgressRingProps> = ({
    completed,
    total,
    size = 36
}) => {
    if (total <= 0) return null;

    const allDone = completed === total;
    const progress = completed / total;
    const radius = 14;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference * (1 - progress);
    const color = allDone ? '#198754' : 'rgb(138, 147, 166)';

    return (
        <span
            className="delmoment-ring"
            aria-label={`${completed} av ${total} delmoment klara`}
        >
            <svg width={size} height={size} viewBox="0 0 36 36">
                <circle
                    cx="18"
                    cy="18"
                    r={radius}
                    fill="none"
                    stroke="#e9ecef"
                    strokeWidth="4"
                />
                <circle
                    cx="18"
                    cy="18"
                    r={radius}
                    fill="none"
                    stroke={color}
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    transform="rotate(-90 18 18)"
                />
            </svg>
            <span className="delmoment-ring__text" style={{ color }}>
                {completed}/{total}
            </span>
            <span className="delmoment-ring__tooltip">
                {completed} av {total} delmoment klara
            </span>
        </span>
    );
};

export default DelmomentProgressRing;
